import { render } from "./PageLayout.vue?vue&type=template&id=5523219c"
import script from "./PageLayout.vue?vue&type=script&lang=js"
export * from "./PageLayout.vue?vue&type=script&lang=js"
script.render = render

export default script